module.exports = __webpack_public_path__ + "img/icon-place.e9198c91.svg";